export default __webpack_public_path__ + "public/images/services/MessageImg.png?375a319f";